// The reactions a regular (non-Premium) Telegram account may set; anything
// else Telegram refuses (REACTION_INVALID). The picker asks Telegram for the
// current list (it adds new ones now and then); this is the fallback.
// Written as Telegram does: ❤ and similar without U+FE0F.
export const TELEGRAM_REACTIONS = [
  '👍',
  '👎',
  '❤',
  '🔥',
  '🥰',
  '👏',
  '😁',
  '🤔',
  '🤯',
  '😱',
  '🤬',
  '😢',
  '🎉',
  '🤩',
  '🤮',
  '💩',
  '🙏',
  '👌',
  '🕊',
  '🤡',
  '🥱',
  '🥴',
  '😍',
  '🐳',
  '❤‍🔥',
  '🌚',
  '🌭',
  '💯',
  '🤣',
  '⚡',
  '🍌',
  '🏆',
  '💔',
  '🤨',
  '😐',
  '🍓',
  '🍾',
  '💋',
  '🖕',
  '😈',
  '😴',
  '😭',
  '🤓',
  '👻',
  '👨‍💻',
  '👀',
  '🎃',
  '🙈',
  '😇',
  '😨',
  '🤝',
  '✍',
  '🤗',
  '🫡',
  '🎅',
  '🎄',
  '☃',
  '💅',
  '🤪',
  '🗿',
  '🆒',
  '💘',
  '🙉',
  '🦄',
  '😘',
  '💊',
  '🙊',
  '😎',
  '👾',
  '🤷‍♂',
  '🤷',
  '🤷‍♀',
  '😡',
];

export const DEFAULT_QUICK_REACTIONS = ['👍', '❤', '🔥', '🤣', '👀', '👌'];

// Telegram writes ❤, ☃, 🕊 and a few others without U+FE0F, and browsers
// then draw them as grey text symbols. Adding it back only changes the look.
const TEXT_STYLE = /([\u2600-\u27BF\u2640\u2642\u{1F54A}])(?!\uFE0F)/gu;
export const displayEmoji = emoji => emoji.replace(TEXT_STYLE, '$1\uFE0F');

// Russian words to find a reaction by in the picker's search.
export const REACTION_NAMES = {
  '👍': 'палец вверх лайк класс',
  '👎': 'палец вниз дизлайк',
  '❤': 'сердце любовь',
  '🔥': 'огонь огонёк',
  '🥰': 'влюблённый сердечки',
  '👏': 'аплодисменты хлопать браво',
  '😁': 'улыбка смех',
  '🤔': 'думаю задумался',
  '🤯': 'взрыв мозга шок',
  '😱': 'ужас крик',
  '🤬': 'ругань злость мат',
  '😢': 'грусть слеза',
  '🎉': 'праздник хлопушка ура',
  '🤩': 'восторг звёзды',
  '🤮': 'тошнит рвота',
  '💩': 'какашка',
  '🙏': 'спасибо молитва пожалуйста',
  '👌': 'окей ок хорошо',
  '🕊': 'голубь мир',
  '🤡': 'клоун',
  '🥱': 'зевок скучно',
  '🥴': 'пьяный',
  '😍': 'влюблён сердца',
  '🐳': 'кит',
  '❤‍🔥': 'горящее сердце страсть',
  '🌚': 'луна',
  '🌭': 'хот-дог',
  '💯': 'сто процентов',
  '🤣': 'ржу смех катаюсь',
  '⚡': 'молния',
  '🍌': 'банан',
  '🏆': 'кубок победа',
  '💔': 'разбитое сердце',
  '🤨': 'сомнение бровь',
  '😐': 'нейтрально',
  '🍓': 'клубника',
  '🍾': 'шампанское',
  '💋': 'поцелуй губы',
  '🖕': 'средний палец',
  '😈': 'чертёнок',
  '😴': 'сон сплю',
  '😭': 'плачу рыдаю',
  '🤓': 'ботаник очки',
  '👻': 'привидение',
  '👨‍💻': 'программист компьютер',
  '👀': 'глаза смотрю',
  '🎃': 'тыква',
  '🙈': 'не вижу обезьяна',
  '😇': 'ангел',
  '😨': 'страх испуг',
  '🤝': 'рукопожатие договорились',
  '✍': 'пишу',
  '🤗': 'обнимаю',
  '🫡': 'салют есть так точно',
  '🎅': 'дед мороз санта',
  '🎄': 'ёлка',
  '☃': 'снеговик',
  '💅': 'маникюр',
  '🤪': 'дурачусь',
  '🗿': 'моаи камень',
  '🆒': 'круто кул',
  '💘': 'сердце стрела',
  '🙉': 'не слышу обезьяна',
  '🦄': 'единорог',
  '😘': 'воздушный поцелуй',
  '💊': 'таблетка',
  '🙊': 'молчу обезьяна',
  '😎': 'крутой очки',
  '👾': 'пришелец игра',
  '🤷‍♂': 'не знаю пожимаю плечами',
  '🤷': 'не знаю пожимаю плечами',
  '🤷‍♀': 'не знаю пожимаю плечами',
  '😡': 'злой гнев',
  // MAX only.
  '😂': 'смех слёзы радости',
  '😮': 'удивление ого',
};
